export default __webpack_public_path__ + "static/media/7minfitness_13.effd08eb.jpg";